// Lines whose bullet background is light (yellow N Q R W) need dark text for
// legibility; everything else uses white text.
export const SUBWAY_DARK_TEXT_LINES = new Set(['N', 'Q', 'R', 'W']);
export default {
    '1': '#EE352E', // 1 2 3 - red (IRT Broadway–7 Av)
    '2': '#EE352E',
    '3': '#EE352E',
    '4': '#00933C', // 4 5 6 - dark green (IRT Lexington Av)
    '5': '#00933C',
    '6': '#00933C',
    '7': '#B933AD', // 7 - purple
    A: '#0039A6', // A C E - blue (IND 8 Av)
    C: '#0039A6',
    E: '#0039A6',
    B: '#FF6319', // B D F M - orange (IND 6 Av)
    D: '#FF6319',
    F: '#FF6319',
    M: '#FF6319',
    G: '#6CBE45', // G - light green (IND Crosstown)
    J: '#996633', // J Z - brown (BMT Jamaica)
    Z: '#996633',
    L: '#A7A9AC', // L - gray (BMT Canarsie)
    N: '#FCCC0A', // N Q R W - yellow (BMT Broadway)
    Q: '#FCCC0A',
    R: '#FCCC0A',
    W: '#FCCC0A',
    S: '#808183', // shuttles - dark gray
};
